import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { Row, Col, Button, Modal, ModalHeader, ModalBody, Input, InputGroup, Form, FormGroup } from 'reactstrap';
import styled from 'styled-components';

import { KickAvenueBrandIcon } from '../PageApp/NavbarDesktopV3/styled';
import BodyCheckout from '../PageCheckout/Detail/BodyCheckout';

const ModalCheckout = props => {
  return (
    <Modal
      className="search-custom-modal modal-fullscreen"
      modalClassName="modal-search"
      wrapClassName="wrapper-search"
      contentClassName="content-search content__filter"
      backdropClassName="backdrop-checkout-content"
      isOpen={props.isOpen}
      toggle={props.onToggle}
      
    >
    <ModalHeader className="checkout-modal-header">
      <KickAvenueBrandIcon src="/images/app-icon.png" className="kickavenue" alt="kickavenue" />
    </ModalHeader>
    <ModalBody>
      <BodyCheckout
        {...props}

        /* From old code */
        //_getLayananPrice = {props._getLayananPrice}
      />
      <Row style={{padding: '0 30px', marginTop: '0.5rem'}}>
        <Col style={{padding: '0'}}>
          <div onClick={props.onToggle} style={{cursor: 'pointer'}}>
            <span>&lt;&lt; Back to Product Page</span>
          </div>
        </Col>
      </Row>
    </ModalBody>
    </Modal>
  )
}

export default ModalCheckout;